import { IComponentConfiguration } from '@kurtosys/ksys-app-components/dist/models/IComponentConfiguration';
import Button from '@kurtosys/ksys-app-components/dist/components/base/Button';
import Card from '@kurtosys/ksys-app-components/dist/components/base/Card';
import Text from '@kurtosys/ksys-app-components/dist/components/base/Text';
import { Heading } from '../components/Heading/Heading';
import { Definitions } from '../components/Definitions/Definitions';
import { Search } from '../components/Search/Search';
import { Dropdown } from '../components/Dropdown/Dropdown';
import { Capabilities } from '../components/Capabilities/Capabilities';

export const LIBRARY_COMPONENTS_CONFIGURATION: IComponentConfiguration = {
	base: {
		grid: {
			components: {
				'base.button': {
					key: 'base.button',
					component: Button,
				},
				'base.card': {
					key: 'base.card',
					component: Card,
				},
				'base.text': {
					key: 'base.text',
					component: Text,
				},
				'heading': {
					key: 'heading',
					component: Heading,
				},
				'definition.list': {
					key: 'definition.list',
					component: Definitions,
				},
				'search': {
					key: 'search',
					component: Search,
				},
				'dropdown': {
					key: 'dropdown',
					component: Dropdown,
				},
				'capabilities': {
					key: 'capabilities',
					component: Capabilities,
				},
			},
		},
	},
};